module.exports = __webpack_public_path__ + "static/media/splash_title.1770b7e3.png";